<template>
  <header class="customer-header">
    <div class="header-content maxW">
      <section class="content-left">
        <div class="catchword">{{ $t("customer.catchword") }}</div>
        <div class="phoneNumber" v-if="info_phone">
          <i class="el-icon-phone"></i>
          <div class="number">{{ info_phone }}</div>
        </div>
      </section>
      <section class="content-right">
        <div class="right-search">
          <el-input
            :placeholder="$t('customer.placeholderSearch')"
            v-model="searchText"
            clearable
          >
            <el-button
              @click="search"
              class="search-btn"
              slot="append"
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </div>
        <div class="user-info">
          <el-popover
            class="popvoer"
            v-if="userInfo"
            placement="bottom-start"
            trigger="hover"
          >
            <p class="safe-exit" @click="loginOut">
              {{ $t("homepage.loginOut") }}
            </p>
            <div slot="reference">
              <el-avatar
                size="small"
                :src="userInfo.avatar_path"
                @error="errorAvatar"
              ></el-avatar>
              <div class="user-name">{{ userInfo.name }}</div>
            </div>
          </el-popover>

          <div class="plase-login" v-else @click="loginOut">
            {{ $t("customer.pleaseLogin") }}{{ userInfo }}
          </div>
        </div>
      </section>
    </div>
    <div class="header-logo">
      <img
        :src="require('@/assets/images/customer/logo@2x.png')"
        alt="logo"
        :draggable="false"
      />
    </div>
  </header>
</template>

<script>
import store from "@/store/index.js";
export default {
  props: {
    info_phone: {
      type: String,
      default: "",
    },
    userInfo: {
      type: Object,
      default: () => {
        return { avatar_path: null, name: null };
      },
    },
  },
  data() {
    return {
      searchText: "",
    };
  },
  watch: {
    userInfo: {
      handler: function (newVal) {
        if( newVal) {
          newVal.avatar_path = newVal.avatar_path.includes("http")
            ? newVal.avatar_path
            : this.API_URL + newVal.avatar_path;
        }
      },
      deep: true,
    },
  },
  computed: {
    // isLogin() {
    //   return this.userInfo ? true : false;
    // },
    // userInfo() {
    //   let userInfo = JSON.parse(sessionStorage.getItem("user_info_str"));
    //   console.log('userInfo------',userInfo)
    //   if (userInfo) {
    //     userInfo.avatar_path = userInfo.avatar_path.includes("http")
    //       ? userInfo.avatar_path
    //       : this.API_URL + userInfo.avatar_path;
    //   }
    //   return userInfo;
    // },
  },
  methods: {
    search() {
      this.$store.commit("Change_Cate", 0);
      this.$store.commit("SET_Customer_Keyword", this.searchText);
    },
    loginOut() {
      this.$message.closeAll();
      this.$message.success("退出成功");
      this.$store.commit("SET_ACTIVEINDEX", 0);
      localStorage.removeItem("token");
      sessionStorage.removeItem("user_info_str");
      this.$router.push("/user-login");

      // sessionStorage.clear();
      // localStorage.clear();
      // window.location.href = location.origin
    },
    errorAvatar() {
      this.userInfo.avatar_path = require("@/assets/images/head@2x.png");
    },
  },
};
</script>

<style scoped lang='scss'>
:deep(.is-focus) {
  border-color: #e62125;
}
.customer-header {
  user-select: none;
  width: 100%;
  height: 4rem;
  background-color: #2c2e3f;
  position: relative;
  border-bottom: #e62126 solid 2px;
  .header-content {
    height: 100%;
    line-height: 4rem;
    display: flex;
    justify-content: space-between;
    .content-left {
      color: #fff;
      display: flex;
      .catchword {
        margin-right: 3rem;
      }
      .phoneNumber {
        display: flex;
        width: 10rem;
        align-items: center;
        i {
          font-size: 1.5rem;
        }
        .number {
          margin-left: 0.4rem;
          :deep(.el-skeleton__item) {
            width: 10rem;
            position: relative;
            top: 4px;
          }
        }
      }
    }
    .content-right {
      display: flex;
      .right-search {
        :deep(.el-input__inner:focus) {
          border-color: red;
        }
        :deep(.el-input-group__append) {
          border: none;
          background-color: #e62126;
          .el-icon-search {
            color: #fff;
            font-size: 1.5rem;
          }
        }
      }

      .el-popover__reference {
        display: flex;
        align-items: center;
      }
      .user-info {
        color: #fff;
        margin-left: 2rem;
        display: flex;
        align-items: center;
        .el-avatar {
          margin-right: 1rem;
        }
        .user-name {
          max-width: 9rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .header-logo {
    z-index: 110;
    position: absolute;
    top: 0;
    left: calc(50% - 80px);
    img {
      height: 160px;
      width: 160px;
    }
  }
}

.el-popover {
  .safe-exit {
    width: 100%;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    margin: auto;
    display: inline-block;
  }

  .safe-exit:hover {
    color: #e62125;
  }
}
</style>
